import NotAssignedTable from './components/notAssignedTable';
import AssignedTable from './components/assignedTable';
import {
  useLazyGetAssignmentStudentsQuery,
  useChangeModeMutation
} from '../../../../../../../../features/authentication/assignmentApislice';
import {
  useAssignStudentsMutation,
  useSetClassFiltersMutation
} from '../../../../../../../../features/authentication/assignApiSlice';
import { useState, useEffect } from 'react';
import { useAssignmentContext } from '../../../../../../context';
import { Form, Button } from 'react-bootstrap';
import CogsImg from '../../../../../../../../assets/images/cogs.png';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomToast from '../../../../../../../../components/Toast';
import AssignmentSettings from '../../../../../../../../components/AssignmentSettings/index';
import ConfirmationModal from '../../../../../../../../components/ConfirmationPopUp';
import DropDownSearch from '../../../../../../../../components/DropDownSearch';
import moment from 'moment';

function AssignCastle() {
  const [activeTab, setActiveTab] = useState(0);
  const [trigger, result] = useLazyGetAssignmentStudentsQuery();
  const { assignmentId } = useAssignmentContext();
  const [selectedClassFilterIds, setSelectedClassFilterIds] = useState([]);
  const [filterClassList, setFilterClassList] = useState([]);
  const [notAssignedStudents, setNotAssignedStudents] = useState([]);
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [assignStudents] = useAssignStudentsMutation();
  const [isAssigningStudents, setIsAssigningStudents] = useState(false);
  const [allNotAssignedStudents, setAllNotAssignedStudents] = useState([]);
  const [setclassFilter] = useSetClassFiltersMutation();
  const [initialLoad, setInitialLoad] = useState(true);
  const [confirmModel, setConfirmModel] = useState(false);
  const [allClassList, setAllClassList] = useState([]);
  const [isIncludeCR, setIsIncludeCR] = useState(false);

  const selectedAssignment = useAssignmentContext();
  const [showAssignmentSettings, setShowAssignmentSettings] = useState(true);
  const [changeMode] = useChangeModeMutation();
  let tabs = [
    <NotAssignedTable
      key="notAssignedTable"
      notAssignedStudents={notAssignedStudents}
      setNotAssignedStudents={setNotAssignedStudents}
      selectedClassFilterIds={selectedClassFilterIds}
      refetchCallback={() => refetch()}
      dataStatus={result}
      showAssignmentSettings={showAssignmentSettings}
      setShowAssignmentSettings={setShowAssignmentSettings}
    />,
    <AssignedTable
      key="assignedTable"
      assignedStudents={assignedStudents}
      setAssignedStudents={setAssignedStudents}
      selectedClassFilterIds={selectedClassFilterIds}
      refetchCallback={() => refetch()}
      dataStatus={result}
      assignmentHasCRQuestions={result}
      isIncludeCRQuestion={isIncludeCR}
      showAssignmentSettings={showAssignmentSettings}
      setShowAssignmentSettings={setShowAssignmentSettings}
    />
  ];

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (!initialLoad) {
      setClassIdsFilter();
    }
    let tempNotAssignStudents = [];
    let distinctUnAssignedStudents = [];
    tempNotAssignStudents = [...allNotAssignedStudents];
    tempNotAssignStudents.forEach((item) => {
      if (selectedClassFilterIds.includes(item.classId)) {
        var matchStudent = distinctUnAssignedStudents.some(
          (student) => student.studentId === item.studentId
        );
        if (!matchStudent) distinctUnAssignedStudents.push(item);
      }
    });
    tempNotAssignStudents = [...distinctUnAssignedStudents];
    setNotAssignedStudents(tempNotAssignStudents);
  }, [selectedClassFilterIds]);

  function refetch() {
    trigger(assignmentId).then((response) => {
      if (response.isSuccess) {
        setFilterClassList(
          response.data.classes.map((item) => {
            return {
              name: item.name,
              id: item.id,
              description: item.coTeacherName,
              isChecked: item.selected
            };
          })
        );
        const persistclassIds = response.data.classes
          .filter((obj) => obj.selected)
          .map((obj) => obj.id);
        setSelectedClassFilterIds(persistclassIds);
        setInitialLoad(false);
        let distinctUnAssignedStudents = [];
        response.data.unassignedStudents.forEach((item) => {
          var matchStudent = distinctUnAssignedStudents.some(
            (student) => student.studentId === item.studentId
          );
          if (!matchStudent) distinctUnAssignedStudents.push(item);
        });
        setIsIncludeCR(response.data.includesCRQuestions);
        setAllNotAssignedStudents(response.data.unassignedStudents);
        setNotAssignedStudents(distinctUnAssignedStudents);
        setAssignedStudents(response.data.assignedStudents);
        setAllClassList(
          response.data.classes.map((item) => {
            return {
              name: item.name,
              id: item.id,
              description: item.coTeacherName,
              isChecked: item.selected
            };
          })
        );
      } else {
        console.log(response.error);
        setNotAssignedStudents([]);
        setAssignedStudents([]);
      }
    });
  }

  const handleClassSelectionChange = (e) => {
    const { key } = e;
    const selected = key !== '000' ? filterClassList.find((v) => v.id == key) : filterClassList;
    let tempValue = [];

    if (key === '000') {
      tempValue = filterClassList.map((item) => ({
        ...item,
        isChecked: !filterClassList.filter((item) => item?.isChecked !== true).length < 1
      }));
    } else {
      tempValue = filterClassList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setFilterClassList(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    setSelectedClassFilterIds(ids);

    let tempAssignStudents = [...assignedStudents];
    tempAssignStudents = tempAssignStudents.map((result) => {
      return result.isChecked == false
        ? result
        : { ...result, isChecked: ids.includes(result.classId) };
    });
    setAssignedStudents(tempAssignStudents);

    let tempNotAssignStudents = [];
    let distinctUnAssignedStudents = [];
    if (key === '000') {
      tempNotAssignStudents = [...allNotAssignedStudents];
      tempNotAssignStudents.forEach((item) => {
        var matchStudent = distinctUnAssignedStudents.some(
          (student) => student.studentId === item.studentId
        );
        if (!matchStudent) distinctUnAssignedStudents.push(item);
      });
      tempNotAssignStudents = [...distinctUnAssignedStudents];
    } else {
      tempNotAssignStudents = [...allNotAssignedStudents];
      tempNotAssignStudents.forEach((item) => {
        if (ids.includes(item.classId)) {
          var matchStudent = distinctUnAssignedStudents.some(
            (student) => student.studentId === item.studentId
          );
          if (!matchStudent) distinctUnAssignedStudents.push(item);
        }
      });
      tempNotAssignStudents = [...distinctUnAssignedStudents];
    }
    tempNotAssignStudents = tempNotAssignStudents.map((result) => {
      return result.isChecked == false
        ? result
        : { ...result, isChecked: ids.includes(result.classId) };
    });

    setNotAssignedStudents(tempNotAssignStudents);
  };

  async function handleAssignStudents() {
    var selectedStudents = [];

    if (activeTab === 0) {
      selectedStudents = notAssignedStudents
        .filter((s) => s.isChecked && selectedClassFilterIds.includes(s.classId))
        .map((student) => ({ studentId: student.studentId, classId: student.classId }));
    } else {
      selectedStudents = assignedStudents
        .filter((s) => s.isChecked && selectedClassFilterIds.includes(s.classId))
        .map((student) => ({ studentId: student.studentId, classId: student.classId }));
    }

    const timedTimeSpan =
      parseInt(selectedAssignment.timedHour) * 60 + parseInt(selectedAssignment.timedMinute);

    if (selectedStudents.length <= 0) {
      CustomToast('Please check at least one student in the list', 'info');
      return;
    }

    if (selectedAssignment.availabilityOption !== 'offline') {
      if (!selectedAssignment.assignmentMode) {
        CustomToast('Please select the assignment mode', 'info');
        return;
      }
    }
    if (selectedAssignment.isTimed && timedTimeSpan <= 0) {
      CustomToast('The time length must be greater than 0 minutes.', 'info');
      return;
    }
    if (selectedAssignment.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
      if(moment(selectedAssignment.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(moment(selectedAssignment.startDate)) || moment(selectedAssignment.endDate).isSame(moment(selectedAssignment.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }

    if (selectedAssignment.retakesEnabled) {
      if (selectedAssignment.retakeLimitValue <= 0) {
        CustomToast('You must select a retake limit', 'info');
        return;
      }
      if (selectedAssignment.retakeQuestion === null) {
        CustomToast(
          'You must select an option for Auto Graded Questions to include on Retakes',
          'info'
        );
        return;
      }
      if (selectedAssignment.includeCR === null) {
        CustomToast('You must select an option for CR Questions to include on Retakes', 'info');
        return;
      }
    }
    if (activeTab === 0) {
      const sharedClasses = filterClassList.filter(
        (item) => item.isChecked && item.description.length > 0
      );
      if (sharedClasses !== undefined && sharedClasses.length > 0) setConfirmModel(true);
      else assignStudentsApiCall();
    } else {
      assignStudentsApiCall();
    }
  }

  const assignStudentsApiCall = async () => {
    var selectedStudents = [];
    if (activeTab === 0) {
      selectedStudents = notAssignedStudents
        .filter((s) => s.isChecked && selectedClassFilterIds.includes(s.classId))
        .map((student) => ({ studentId: student.studentId, classId: student.classId }));
    } else {
      selectedStudents = assignedStudents
        .filter((s) => s.isChecked && selectedClassFilterIds.includes(s.classId))
        .map((student) => ({ studentId: student.studentId, classId: student.classId }));
    }
    const timedTimeSpan =
      parseInt(selectedAssignment.timedHour) * 60 + parseInt(selectedAssignment.timedMinute);
    let options = {
      students: selectedStudents,
      selfAssign: false,
      availability: selectedAssignment.availabilityOption,
      assignmentMode:
        selectedAssignment.assignmentMode === '' ? 'open' : selectedAssignment.assignmentMode,
      allowAnswerChange: selectedAssignment.allowAnswerChange,
      showGrade: selectedAssignment.showGrade,
      startDate:
        selectedAssignment.startDate != ''
          ? moment(selectedAssignment.startDate).format('YYYY/MM/DD h:mm A')
          : '',
      endDate:
        selectedAssignment.endDate != ''
          ? moment(selectedAssignment.endDate).format('YYYY/MM/DD h:mm A')
          : '',
      studentFileUpload: selectedAssignment.studentFileUpload,
      timed: selectedAssignment.isTimed,
      timeSpan: timedTimeSpan,
      practice: true,
      assignRetake: selectedAssignment.retakesEnabled,
      masteryLevel: selectedAssignment.masteryValue,
      retakeMode: selectedAssignment.assignmentMode,
      scoreRetries: selectedAssignment.scoreRetries,
      retakeLimit: selectedAssignment.retakeLimitValue,
      retakeAvailability: selectedAssignment.availabilityOption,
      retakeStartDate:
        selectedAssignment.startDate != ''
          ? moment(selectedAssignment.startDate).format('YYYY/MM/DD h:mm A')
          : '',
      retakeEndDate:
        selectedAssignment.endDate != ''
          ? moment(selectedAssignment.endDate).format('YYYY/MM/DD h:mm A')
          : '',
      retakeTimed: selectedAssignment.isTimed,
      retakeTimeSpan: timedTimeSpan,
      retakeQuestion: selectedAssignment.retakeQuestion,
      includeCR: selectedAssignment.includeCR,
      autoLockQuestions: selectedAssignment.autoLockQuestions,
      allowLangChange: selectedAssignment.allowLangChange,
      useCalc: selectedAssignment.calculatorEnabled ? 1 : 0,
      useProtractor: selectedAssignment.useProtractor ? 1 : 0,
      useRuler: selectedAssignment.useRuler ? 1 : 0,
      timeOnTask: selectedAssignment.timeOnTaskEnabled,
      period: selectedAssignment.timeOnTaskSeconds,
      lockBrowser: selectedAssignment.lockBrowser,
      photoMathBlock: selectedAssignment.photoMathBlock,
      autoStartCRUponGrading: selectedAssignment.autoStartCRUponGrading,
      cranswerToolId: selectedAssignment.crAnswerToolType,
      calculatorType: selectedAssignment.calculatorType
    };
    setIsAssigningStudents(true);

    if (activeTab === 0) {
      try {
        options.assignmentIds = [parseInt(assignmentId)];
        options.randomized = selectedAssignment.randomized;
        options.textToSpeech = selectedAssignment.textToSpeech;

        const allAssignedDataResponse = await assignStudents(options).unwrap();
        setAssignedStudents([]);
        if (allAssignedDataResponse.length > 0) {
          CustomToast(
            `${allAssignedDataResponse[0].studentsAssigned} student${
              allAssignedDataResponse[0].studentsAssigned == 1 ? ' has' : 's have'
            } been assigned`,
            'success'
          );
          setIsAssigningStudents(false);
          setConfirmModel(false);
          refetch();
        } else {
          CustomToast('Error! Couldn\'t Assign', 'error');
          setIsAssigningStudents(false);
        }
      } catch (ex) {
        console.log(ex);
        CustomToast(ex.data, 'error');
        setIsAssigningStudents(false);
        setConfirmModel(false);
      }
    } else {
      try {
        options.activity = 1;
        options.textToSpeech = selectedAssignment.textToSpeech;
        options.allowLanguageChange = selectedAssignment.allowLangChange;

        const changeModeDataResponse = await changeMode({
          assignmentId: assignmentId,
          data: options
        }).unwrap();
        setNotAssignedStudents([]);
        if (changeModeDataResponse > 0) {
          CustomToast(
            `${changeModeDataResponse} student${
              changeModeDataResponse == 1 ? ' assignment has' : '\'s assignments have'
            } been changed`,
            'success'
          );
          setIsAssigningStudents(false);
          refetch();
        } else {
          CustomToast('Error! Couldn\'t change assignments', 'error');
          setIsAssigningStudents(false);
        }
      } catch (ex) {
        console.log(ex);
        CustomToast('Error! Couldn\'t change assignments', 'error');
        setIsAssigningStudents(false);
      }
    }
  };

  const setClassIdsFilter = async () => {
    try {
      await setclassFilter(selectedClassFilterIds).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Form.Group style={{ width: '25%', marginRight: '0.5vw' }}>
        <Form.Label htmlFor="classDropdown">Class</Form.Label>

        <DropDownSearch
          value={filterClassList}
          setValue={setFilterClassList}
          dropdownId="classesFilter"
          placeholder="Filter Classes"
          handleChange={(e) => handleClassSelectionChange(e)}
          selectedId={selectedClassFilterIds}
          setSelectedId={setSelectedClassFilterIds}
          description={true}
          selectAllText="All Classes"
          coteacherText={true}
          allData={allClassList}
        />
      </Form.Group>
      <div className="d-inline-flex my-4 assignStudentsTabs">
        <div className={`btn ${activeTab == 0 ? 'active' : ''}`} onClick={() => setActiveTab(0)}>
          Not Assigned
          <span className={activeTab == 0 ? 'activeCount' : 'count'}>{` (${
            notAssignedStudents.filter((s) => selectedClassFilterIds.includes(s.classId)).length
          })`}</span>
        </div>
        <div className={`btn ${activeTab == 1 ? 'active' : ''}`} onClick={() => setActiveTab(1)}>
          Assigned
          <span className={activeTab == 1 ? 'activeCount' : 'count'}>{` (${
            assignedStudents.filter(
              (item) => !item.isRemoved && selectedClassFilterIds.includes(item.classId)
            ).length
          })`}</span>
        </div>
      </div>

      <div className={`assignmentSettingsPopOut ${showAssignmentSettings ? '' : 'hidden'}`}>
        <AssignmentSettings
          allowRetakesOption={true}
          headingDescription={false}
          availabilityRequired={true}
          modesRequired={true}
          showBetaButton={true}
          noColumn={true}
          allowOfflineMode={true}
          randomizedQuestion={activeTab === 0 ? true : false}
          disabledTextSpeach={true}
          isSelfAssign={false}
        />

        <div className="assignButtonsRow gap-3">
          <Button
            className="btn-width"
            variant="castleGray"
            onClick={() => {
              setShowAssignmentSettings(false);
            }}>
            Cancel
          </Button>
          <Button
            className='btn-width'
            variant="castleRed"
            onClick={() => handleAssignStudents()}
            disabled={isAssigningStudents}>
            {`${activeTab === 0 ? 'Assign' : 'Change Mode'}`}
          </Button>
        </div>

        <div className="assignmentSettingsCloseBtn">
          <FontAwesomeIcon
            className="ms-2"
            size="2x"
            icon={faXmark}
            onClick={() => setShowAssignmentSettings(false)}
          />
        </div>
      </div>

      {tabs[activeTab]}
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => assignStudentsApiCall()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          'To assign this assignment to the class(es), the class owner(s) must have assignment access. Click OK to make selected class owner(s) as co-teacher for this assignment then assign the assignment.'
        }
        cancelButton={'Cancel'}
        confirmButton={'OK'}
        titleName={'Class owner has no assignment ownership'}
        hideheader={false}
      />
    </>
  );
}

export default AssignCastle;
